(function () {
    'use strict';

    angular
        .module('cacmEventModule')
        .controller('cacmEventFullController', Controller);

    Controller.$inject = ['$scope', 'cacmService', '$state'];

    function Controller($scope, cacmService, $state) {
        $scope.isLoading = false;

        $scope.isGroupParent = function () {
            return $scope.boxModel.IsGrouped && !$scope.boxModel.ParentID;
        };

        $scope.ungroupAll = function () {
            cacmService
                .ungroupAllFromGroup($scope.boxModel.CACMEventID)
                .then(function () {
                    $state.go('cacm', {sourceType: 'CACMEvent'}, {location: 'replace'});
                });
        };
    }
})();